import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { SimpleCorrectionHeader } from '@/components/CorrectionContent/SimpleCorrectionHeader';
import { SimpleCorrectionContent } from '@/components/CorrectionContent/SimpleCorrectionContent';
import { ActiveCourseContext } from '@/components/Contexts/ActiveCourseContext';
import { ActiveStudentContext } from '@/components/Contexts/ActiveStudentContext';
import { ActiveLessonContext } from '@/components/Contexts/ActiveLessonContext';
import { ActiveLessonStatusesContext } from '@/components/Contexts/ActiveLessonStatusesContext';
import { Spinner, PersonAvatar } from '@teo/components';
import { useGet } from '@/query/fetchHooks';
import { NavContext } from '@/components/NavContext';
import { config } from '@/config';

const SimpleResultPage = ({ coorectionPage }: { coorectionPage?: boolean }) => {
  const { studentId, courseId, lessonId } = useParams();
  const { setNavDisabled } = useContext(NavContext);

  const { course, setCourse } = useContext(ActiveCourseContext);
  const { student, setStudent } = useContext(ActiveStudentContext);
  const { lesson, setLesson } = useContext(ActiveLessonContext);
  const { lessonStatus, setLessonStatus } = useContext(
    ActiveLessonStatusesContext
  );
  const [correction, setCorrection] = useState<any>(null);
  const [feedback, setFeedback] = useState<any>(undefined);
  const [loaded, setLoaded] = useState(false);

  useGet(`/coursedetail/${courseId}`, {
    onSuccess: (result: any) => setCourse(result?.data || null),
  });
  useGet(`/student/${courseId}/${studentId}`, {
    onSuccess: (result: any) => setStudent(result?.data || null),
  });
  useGet(`/usedcourselesson/${courseId}/${lessonId}`, {
    onSuccess: (result: any) => setLesson(result?.data || null),
  });
  useGet(
    `/lessonstatuses?courseId=${courseId}&userId=${studentId}&lessonId=${lessonId}`,
    {
      onSuccess: (result: any) => setLessonStatus(result?.data[0] || null),
    }
  );
  useGet(
    `${config.teodoc}/corrections/list2?lessonId=${lessonId}&userId=${studentId}&courseId=${courseId}`,
    {
      enabled: lessonStatus?.status === 'corrected',
      onSuccess: (result: any) => {
        setFeedback(result?.data[0]?.correction?.feedback || null);
        setCorrection(result?.data[0] || null);
      },
    }
  );

  useEffect(() => {
    if (lesson && student && course && lessonStatus) {
      setLoaded(true);
    }
  }, [lesson, student, course, lessonStatus]);

  useEffect(() => {
    setNavDisabled(true);
    return () => setNavDisabled(false);
  });

  if (!loaded) {
    return (
      <div className="fixed inset-0 z-[11] flex bg-white">
        <div className="m-auto">
          <Spinner
            ariaLabel="Loading spinner"
            className="!h-16 !w-16 border-grey-08"
          />
        </div>
      </div>
    );
  }

  const fullName =
    student?.username ||
    [student?.firstName, student?.lastName].filter(Boolean).join(' ');

  return (
    <>
      {/*<div className="flex items-center justify-between border-b border-grey-300 bg-white px-6 py-4 text-sm font-medium">
        <div className="flex items-center gap-4">
          <PersonAvatar
            id={student?.id}
            name={fullName}
            imageSrc={student?.picture || undefined}
          />
          <span>{fullName}</span>
        </div>
        <div className="text-base font-semibold truncate text-center flex-1">
          {course?.courseName || course?.name}
        </div>
        <div className="w-[120px] text-right text-sm text-gray-500" />
      </div>
      */}

      <SimpleCorrectionHeader
        coorectionPage={coorectionPage}
        course={course}
        student={student}
        lesson={lesson}
        lessonStatus={lessonStatus}
        correction={correction}
      />

      <div className="mt-7">
        <SimpleCorrectionContent
          courseId={courseId}
          studentId={studentId}
          lessonId={lessonId}
          coorectionPage={coorectionPage}
          course={course}
          student={student}
          lesson={lesson}
          lessonStatus={lessonStatus}
          correction={correction}
          feedback={feedback}
        />
      </div>
    </>
  );
};

export default SimpleResultPage;
